var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'an-accordion-item',
    { 'an-accordion-item--open': _vm.active, 'an-accordion-item__ready': _vm.ready }
  ]},[_c('div',{staticClass:"an-accordion-item__header",on:{"click":function($event){return _vm.$parent.changeActive(_vm.index)}}},[_vm._t("header")],2),(_vm.active)?_c('div',{staticClass:"an-accordion-item__content"},[_vm._t("content")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }